import PageHeader from "@/components/page-header";
import { HelpCatalog } from "@/components/registrant/help/help-portal";
import { createFileRoute } from "@tanstack/react-router";
import { useState } from "react";

export const Route = createFileRoute("/registrant/help/")({
  component: RegistrantHelpIndex,
});

export function RegistrantHelpIndex() {
  const [search, setSearch] = useState("");
  return (
    <div className="flex w-full flex-col">
      <PageHeader
        title="Help Center"
        subtitle="Search or browse topics for the registrant portal"
        className="mb-6"
      />
      <HelpCatalog search={search} onSearchChange={setSearch} />
    </div>
  );
}
